'use client';

import { CONFIG } from '@frameio/config';
import { isUXPEnvironment } from '@frameio/utils/config';
import { convertMillisecondsToReadableTimestamp } from '@frameio/utils/formatters';
import { useGetUxpHostInfoQuery } from '../../shared/gql/queries/generated/GetUxpHostInfo';

/**
 * returns a string identifying the build version, including the frameio-uxp
 * host extension version if connected
 * @example `_v2027-01-01-abcdef1 (STAGING), frameio-uxp_v0.0.0-abcdef1`
 */
export function usePremiereBuildIdentifier() {
  const { pluginVersion: uxpHostPluginVersion, schemaVersion } =
    useGetUxpHostInfoQuery({
      context: { resolveWithUXP: true },
      skip: !isUXPEnvironment(),
    })?.data?.uxpHostInfo || {};

  const selfVersion = convertMillisecondsToReadableTimestamp(
    process.env.NEXT_PUBLIC_BUILD_TIMESTAMP || ''
  )
    .substring(0, 10)
    .replaceAll('-', '');

  let buildIdentifier = `v${selfVersion}`;

  const commit = process.env.NEXT_PUBLIC_GIT_COMMIT_SHA?.substring(0, 7);
  if (commit) {
    buildIdentifier += `-${commit}`;
  }

  const appEnvironment = CONFIG.name?.split('_')?.[0];
  if (!['PROD', 'LOCAL'].includes(appEnvironment)) {
    buildIdentifier += ` (${appEnvironment})`;
  }

  if (uxpHostPluginVersion) {
    buildIdentifier += `, uxp-plugin_v${uxpHostPluginVersion}`;
  }

  if (schemaVersion) {
    buildIdentifier += `, schema_v${schemaVersion}`;
  }

  return buildIdentifier;
}
